import { applicationsRef, files } from "@/firebase.js";
import Vue from "vue";
import { uuid } from 'vue-uuid'
import moment from 'moment'

export default {
  state: {
    selectedApplication: null,
    applicantData: null
  },
  mutations: {
    setSelectedApplication (state, application) {
      state.selectedApplication = application
    }
  },
  actions: {
    async loadApplication({ commit, dispatch, rootState }, id) {
      let applicationQry  = await applicationsRef.doc(id).get()
      let application = applicationQry.data()

      commit("setSelectedApplication", application);
    },
    async saveTenantCount({ commit }, data) {
      if (isNaN(data.nonAdultTenants)) {
        data.nonAdultTenants = 0;
      }
      if (isNaN(data.adultTenants)) {
        data.adultTenants = 1;
      }
      await applicationsRef.doc(data.applicationID).update({
        nonAdultTenants: Number(data.nonAdultTenants),
        adultTenants: Number(data.adultTenants)
      });
    },
    async addApplicant({ state }, data) {
      let _application = state.selectedApplication;
      let _newTenant = {
        applicantID: uuid.v1(),
        givenNames: data.applicant.givenNames ? data.applicant.givenNames : '',
        surname: data.applicant.surname ? data.applicant.surname : '',
        email: data.applicant.email ? data.applicant.email : '',
        homePhone: data.applicant.phone ? data.applicant.phone : '',
        isHeadTenant: false,
        lastUpdated: new Date(),
      };
      _application.applicants.push(_newTenant);
      await applicationsRef.doc(data.applicationID).update({applicants: _application.applicants});
    },
    async saveApplication({ commit, dispatch, state }, data) {
      let _application = state.selectedApplication

      let idx = _application.applicants.findIndex((applicant) => {
        return applicant.applicantID == data.applicantID;
      });
      if (data.dateOfBirth) {
        data.dateOfBirth = moment(data.dateOfBirth).toDate();
      }
      data.lastUpdated = new Date();
      if (data.identificationImage) {
        let imageFile = await files.child('identificationImages/' + data.applicantID).put(data.identificationImage.file, data.identificationImage.metadata);
        let downloadUrl = await imageFile.ref.getDownloadURL();
        data.identificationImageUploaded = true;
        data.identificationImageUrl = downloadUrl;
        delete data.identificationImage
      }
      _application.applicants[idx] = data;
      await applicationsRef.doc(data.applicationID).update({applicants: _application.applicants});
    }
  },
  getters: {
    selectedApplication (state) {
      return state.selectedApplication;
    }
  }
};
